module.exports = __webpack_public_path__ + "img/1440.1f747f6d.jpg";